export const ADD = "product/add";
export const DECREASE = "product/decreaseStock";
export const INCREASE = "product/increaseStock";
